// extracted by mini-css-extract-plugin
export default {"tabTitleRow":"epB_MhfjLsvXAerBhdw2","titleBox":"OYOzf9pcalvG49CEROtB"};